'use client';

import { Search } from 'lucide-react';
import { useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';
import styles from './StartpageHero.module.scss';

interface StartpageSearchButtonProps {
  searchPage: string;
  totalHits: number;
}

export const StartpageSearchButton = ({ searchPage, totalHits }: StartpageSearchButtonProps) => {
  const t = useTranslations('pages.startpage.hero');
  const router = useRouter();

  const handleClick = () => {
    router.push(searchPage);
  };

  return (
    <button
      id="startpage-hero-search-button"
      onClick={handleClick}
      type="button"
      className={styles.searchBarButton}
    >
      <Search aria-hidden="true" />
      {t('searchBar.placeholder', {
        value: totalHits,
      })}
    </button>
  );
};
